import React, { useState } from "react";
import {
    Accordion,
    AccordionBody,
    AccordionHeader,
    AccordionItem, Col, Container
} from "reactstrap";
import styles from "./styles.module.scss";

export const SolutionsAccordion = ({
  className,
  sectionId,
  content,
  post,
  backgroundClrOpen,
}) => {
  // Create a state variable to track the open accordion item and its toggle class
  const [openItem, setOpenItem] = useState(null);

  const classToggle = (id) => {
    // If the clicked item is already open, close it
    if (openItem === id) {
      setOpenItem(null);
    } else {
      // Otherwise, open the clicked item
      setOpenItem(id);
    }
  };

  const [open, setOpen] = useState("");
  const toggle = (id) => {
    if (open === id) {
      setOpen();
    } else {
      setOpen(id);
    }
  };
  return (
    <section id={sectionId} className={`${styles.root} ${className}`}>
      <Container>
        {content ? (
          <div className="mb-5 heading">
            <div dangerouslySetInnerHTML={{ __html: content }} />
          </div>
        ) : (
          ""
        )}
        <Accordion open={open} toggle={toggle} className="row m-0">
          {post?.map((post, index) => (
            <Col
              key={index}
              md={6}
              lg={4}
              className={`mb-4 item rounded-4 ${
                open === `${index}` ? "open" : ""
              }`}
              style={{ backgroundColor: backgroundClrOpen }}
            >
              <AccordionItem
                className={`border-0 bg-transparent position-relative`}
              >
                <AccordionHeader
                  targetId={`${index}`}
                  tag="div"
                  className={`${post.url_slug ? "stretched-link" : ""} mb-4`}
                  onClick={() => { post.url_slug ? window.location.href = post.url_slug : classToggle(`${index}`); }}
                >
                  {post?.title}
                </AccordionHeader>
                <div>
                  {post?.short_description ? (
                    <div
                      className=""
                      dangerouslySetInnerHTML={{
                        __html: post?.short_description,
                      }}
                    />
                  ) : null}
                </div>
                <AccordionBody accordionId={`${index}`}>
                  {post?.content ? (
                    <div
                      className=""
                      dangerouslySetInnerHTML={{ __html: post?.content }}
                    />
                  ) : null}
                </AccordionBody>
              </AccordionItem>
            </Col>
          ))}
        </Accordion>
      </Container>
    </section>
  );
}

export default SolutionsAccordion;